module.exports = __webpack_public_path__ + "fonts/Lato-300-latin-ext3.eaf671b.woff2";